import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import mapModule from "highcharts/modules/map";
import apiClient from "../../utils/apiClient";

mapModule(Highcharts);

const LecturersByProvinceChart = () => {
  const [mapData, setMapData] = useState(null);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchTopology = async () => {
      try {
        const response = await fetch(
          "https://code.highcharts.com/mapdata/countries/id/id-all.topo.json"
        );
        const topology = await response.json();
        setMapData(topology);
        Highcharts.maps["id"] = topology;
      } catch (error) {
        console.error("Error fetching topology data:", error);
      }
    };

    const fetchData = async () => {
      try {
        const response = await apiClient.get(
          "/users/role/province-count?role=Dosen"
        );
        setChartData(response.data.data);
      } catch (error) {
        console.error("Error fetching data from API:", error);
      }
    };

    fetchTopology();
    fetchData();
  }, []);

  const formattedChartData = Object.entries(chartData || {}).map(
    ([provinceId, userCount]) => [provinceId, userCount]
  );

  const mapOptions = {
    chart: {
      map: "id",
    },
    title: {
      text: null,
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: "bottom",
      },
    },
    colorAxis: {
      min: 0,
      minColor: "#ff9991",
      maxColor: "#c41104",
    },
    series: [
      {
        data: formattedChartData,
        mapData: Highcharts.maps["id"],
        joinBy: "hc-key",
        name: "Jumlah Dosen",
        states: {
          hover: {
            color: "#BADA55",
          },
        },
        dataLabels: {
          enabled: true,
          format: "{point.name}",
        },
      },
    ],
  };

  return (
    <div>
      {mapData && (
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={"mapChart"}
          options={mapOptions}
        />
      )}
    </div>
  );
};

export default LecturersByProvinceChart;